import { createFileRoute } from '@tanstack/react-router'
import SettingsOrganizationTeamsPage from '@/components/pages/Settings/organization/SettingsOrganizationTeamsPage/SettingsOrganizationTeamsPage'

export const Route = createFileRoute('/$workspaceName/$environment/organization-settings/teams')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SettingsOrganizationTeamsPage />
}
